/* Lazy loader for the Google Maps JS API (with the "places" library).

Ensures the script is only added to the DOM once, then all callers await the same
promise. If REACT_APP_GOOGLE_MAPS_API_KEY is missing, resolves to `null` so the
UI can degrade to manual input.
*/

let loadPromise = null;

export function loadGoogleMaps() {
    if (typeof window === "undefined") return Promise.resolve(null);
    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!key) return Promise.resolve(null);
    if (window.google && window.google.maps && window.google.maps.places) {
        return Promise.resolve(window.google);
    }
    if (loadPromise) return loadPromise;
    loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&v=weekly`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve(window.google);
        script.onerror = () => {
            loadPromise = null; // allow retry
            reject(new Error("Google Maps failed to load"));
        };
        document.head.appendChild(script);
    });
    return loadPromise;
}
